import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom'; 
import { Box, Typography, TextField, Button, Avatar, FormControlLabel, Radio, RadioGroup, FormControl, InputLabel } from '@mui/material';
import { getCurrentIdentity } from '../userIdentity';
import DndSheet from './DndSheet';

const Profile = () => {
  const { userId: paramUserId } = useParams();
  
  const [avatar, setAvatar] = useState(null);
  const [nick, setNick] = useState('');
  const [description, setDescription] = useState('');
  const [appearance, setAppearance] = useState('');
  const [gender, setGender] = useState('');
  const [errors, setErrors] = useState({});
  const [userId, setUserId] = useState(null);
  const [currentIdentityId, setCurrentIdentityId] = useState(null);

  useEffect(() => {
      let mounted = true;

      const loadIdentity = async () => {
        const identity = await getCurrentIdentity();
        if (!mounted) return;

        if (identity?.userId) {
          setCurrentIdentityId(identity.userId);
        }

        // <-- 2. ВОТ СЮДА ВСТАВЛЯЕМ ЛОГИКУ:
        const targetUserId = paramUserId || identity?.userId;
        setUserId(targetUserId);

        if (targetUserId) {
          fetchProfile(targetUserId);
        }
      };

      loadIdentity();

      return () => {
        mounted = false;
      };
    }, [paramUserId]);

  const fetchProfile = async (userId) => {
    try {
      const response = await fetch(`/api/profile/${userId}`);
      if (response.ok) {
        const data = await response.json();
        setAvatar(data.avatar || null);
        setNick(data.nick || '');
        setDescription(data.description || '');
        setAppearance(data.appearance || '');
        setGender(data.gender || '');
      }
    } catch (error) {
      console.error('Error fetching profile:', error);
    }
  };


  const handleAvatarChange = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onloadend = () => {
        setAvatar(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const validate = () => {
    const newErrors = {};
    if (nick.length > 25) newErrors.nick = 'Максимум 25 символов';
    if (description.length > 3000) newErrors.description = 'Максимум 3000 символов';
    if (appearance.length > 3000) newErrors.appearance = 'Максимум 3000 символов';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate() || !userId) {
      alert('Ошибка');
      return;
    }

    try {
      const response = await fetch('/api/profile', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId, avatar, nick, description, appearance, gender }),
      });

      if (response.ok) {
        alert('Профиль сохранен');
      } else {
        alert('Ошибка');
      }
    } catch (error) {
      alert('Не');
    }
  };

  const isOwnProfile = !paramUserId || String(paramUserId) === String(currentIdentityId);

  return (
    <Box sx={{ p: 2, overflowY: 'auto' }}>
      <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold', textAlign: 'center' }}>
        Профиль
      </Typography>
      
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
        <label htmlFor="avatar-upload">
          <Avatar src={avatar} sx={{ width: 100, height: 100, cursor: 'pointer', border: '2px solid #333' }} />
          <input id="avatar-upload" type="file" accept="image/*" onChange={handleAvatarChange} style={{ display: 'none' }} />
        </label>
      </Box>

      <Typography variant="body2" sx={{ textAlign: 'center', mb: 2, fontStyle: 'italic' }}>
        Добавь аватар
      </Typography>

      <TextField
        label="Введи свой ник"
        value={nick}
        onChange={(e) => setNick(e.target.value)}
        fullWidth
        margin="normal"
        error={!!errors.nick}
        helperText={errors.nick}
        InputLabelProps={{ shrink: true }}
        sx={{ '& .MuiFormLabel-root': { fontStyle: 'italic' } }}
      />

      <TextField
        label="Введи свое описание"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        fullWidth
        multiline
        rows={3}
        margin="normal"
        error={!!errors.description}
        helperText={errors.description}
        InputLabelProps={{ shrink: true }}
        sx={{ '& .MuiFormLabel-root': { fontStyle: 'italic' } }}
      />

      <FormControl fullWidth margin="normal">
        <InputLabel shrink sx={{ fontStyle: 'italic' }}>Укажи свой пол</InputLabel>
        <RadioGroup value={gender} onChange={(e) => setGender(e.target.value)} row>
          <FormControlLabel value="Мужчина" control={<Radio />} label="Мужчина" />
          <FormControlLabel value="Женщина" control={<Radio />} label="Женщина" />
        </RadioGroup>
      </FormControl>

      <TextField
        label="Опиши свою внешность"
        value={appearance}
        onChange={(e) => setAppearance(e.target.value)}
        fullWidth
        multiline
        rows={3}
        margin="normal"
        error={!!errors.appearance}
        helperText={errors.appearance}
        InputLabelProps={{ shrink: true }}
        sx={{ '& .MuiFormLabel-root': { fontStyle: 'italic' } }}
      />

    {isOwnProfile && (
        <Button variant="contained" fullWidth onClick={handleSubmit} sx={{ mt: 2, borderRadius: '20px' }}>
          Сохранить
        </Button>
      )}

      {/* D&D Лист отображается корректно после получения userId */}
      {userId && <DndSheet userId={userId} isOwnProfile={isOwnProfile} />}
    </Box>
  );
};

export default Profile;